export const QUOTE_TAG_TYPE_MAPPING = {
    industry: 'industries',
    product_review_section: 'topics', 
    strategic_question: 'themes', 
    custom: 'vendor_custom_tags'
}

export const QUOTE_TAG_TYPE_DISPLAY = {
    industries: 'By Industry',
    topics: 'By Topic',
    themes: 'By Theme',
    vendor_custom_tags: 'Custom Tags'
}

export const JSON_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

export const VENDOR_TAG_TYPE = QUOTE_TAG_TYPE_MAPPING.custom;

export const QUOTE_DELETE_POPUP_HEADER = "Delete this quote?";
export const QUOTE_DELETE_POPUP_BODY = "This change will remove this saved quote and any tags it was assigned.";
export const QUOTE_DELETE_CONFIRM = "Confirm delete";

export const TAGS_LIST_MAX_HEIGHT = "85px";

export const COMPANY_NAME = 'PeerSpot';
export const COMPANY_DOMAIN = 'peerspot.com';

export const EMAIL_PATTERN = /\S+@\S+\.\S{2,}/;
export const PASSWORD_PATTERN = /^(?=.*?[a-z])(?=.*?[0-9]).{8,70}$/i;

export const VALID_NAME_PATTERN = /^[\p{L}'.,()\-\s]+$/u;
export const GENERIC_VALIDATION_PATTERN = /^[\p{L}0-9\s'.,\-&()\/+:#@]+$/u;

export const LEADGEN_TOGGLE_RESET_TIME = 3000;